import { ClientGateway } from "@kex/api";
import axios from "axios";

export const apiConfig = new ClientGateway.Configuration();

export const publicApiAxiosInstance = axios.create();
export const privateApiAxiosInstance = axios.create();

export const authApi = new ClientGateway.AuthApi(
  apiConfig,
  undefined,
  publicApiAxiosInstance,
);
export const generalApi = new ClientGateway.GeneralApi(
  apiConfig,
  undefined,
  privateApiAxiosInstance,
);
export const userApi = new ClientGateway.UserApi(
  apiConfig,
  undefined,
  privateApiAxiosInstance,
);
export const sessionApi = new ClientGateway.SessionsApi(
  apiConfig,
  undefined,
  privateApiAxiosInstance,
);
export const settingsApi = new ClientGateway.SettingsApi(
  apiConfig,
  undefined,
  privateApiAxiosInstance,
);
export const assetsApi = new ClientGateway.AssetsApi(
  apiConfig,
  undefined,
  privateApiAxiosInstance,
);
export const exchangePairsApi = new ClientGateway.ExchangePairsApi(
  apiConfig,
  undefined,
  privateApiAxiosInstance,
);
export const ordersApi = new ClientGateway.OrdersApi(
  apiConfig,
  undefined,
  privateApiAxiosInstance,
);
export const requisitesApi = new ClientGateway.RequisitesApi(
  apiConfig,
  undefined,
  privateApiAxiosInstance,
);
export const paymentSystemsApi = new ClientGateway.PaymentSystemsApi(
  apiConfig,
  undefined,
  privateApiAxiosInstance,
);
